/**
 * A rule's words with its amounts drawn by `Money` — the only component that
 * renders currency (rule 4). `ruleText` builds the pieces and stays pure; this
 * is where a `{ cents }` piece becomes "$15.99".
 */
import { Money } from '../../platform/primitives/Money'
import { conditionParts, whenParts, type Names, type Part } from './ruleText'
import type { ConditionDraft, RuleDraft } from './ruleWire'

/** Whole units drop the ".00" ("over $1,000"); anything else shows its cents. */
const display = (cents: number) => (cents % 100 === 0 ? 'whole' : 'full')

function Parts({ parts }: { parts: Part[] }) {
  return (
    <>
      {parts.map((p, i) =>
        // A sentence's pieces have no ids; their position is their identity,
        // and the list is rebuilt whole from the draft on every render.
        typeof p === 'string' ? (
          <span key={`w-${i}`}>{p}</span>
        ) : (
          <Money key={`m-${i}`} cents={p.cents} display={display(p.cents)} muted />
        ),
      )}
    </>
  )
}

export function ConditionSentence({ cond, names }: { cond: ConditionDraft; names: Names }) {
  return <Parts parts={conditionParts(cond, names)} />
}

export function WhenSentence({ draft, names }: { draft: RuleDraft; names: Names }) {
  return <Parts parts={whenParts(draft, names)} />
}
